module.exports = __webpack_public_path__ + "img/dufour-beige-icon.a30ff19.webp";